import { useState, useEffect } from "react";
import { getData } from "../../../utils/fetch.js"

import Node from "./Skilltree/Node";
import css from "./index.module.css";
import Header from "../../../components/Header";
import Connection from "./Skilltree/Connection";
import Loading from "../../../components/Loading";

/**
 * Displays Missions-page in form of a cklickable skilltree for a student.
 * @param {String} studentId 64 character uuid of given student
 */
const Missions = ({ studentId }) => {
const [missions, setMissions] = useState(null);
const [selectedNode, setSelectedNode] = useState("");
const [studentToMission, setStudentToMission] = useState(null);

useEffect(() => {
  getData("/api/studentToMission").then(data => setStudentToMission(data.filter(e => e.student_id === studentId)));
  getData("/api/missions").then(data => setMissions(data));
}, [studentId]);

  if(missions === null) {
    return <Loading />
  } else if (missions !== null && missions.length === 0) {
    return <Loading />
  } else if (missions.length > 0) {
  return (
    <div className={css.page}>
      <Header isTeacher={false} nav="Mission" />
      <div className={css.container}>
        <svg width={1020} height={550}>
          <Connection from={{x: 305, y: 175}} to={{x:305, y:225}} prequisiteId={missions[0].prequisite_id}  studentToMission={studentToMission}/>

          {/* nach leds */}
          <Connection from={{x: 380, y: 225}} to={{x:380, y:250}} prequisiteId={missions[1].prequisite_id} studentToMission={studentToMission}/>
          <Connection from={{x: 80, y: 225}} to={{x:530, y:225}} prequisiteId={missions[1].prequisite_id} studentToMission={studentToMission}/>
          <Connection from={{x: 80, y: 225}} to={{x:80, y:275}} prequisiteId={missions[1].prequisite_id}  studentToMission={studentToMission}/>
          <Connection from={{x: 230, y: 225}} to={{x:230, y:275}} prequisiteId={missions[1].prequisite_id}  studentToMission={studentToMission}/>
          <Connection from={{x: 530, y: 225}} to={{x:530, y:275}} prequisiteId={missions[1].prequisite_id}  studentToMission={studentToMission}/>
          
          {/* nach analog read */}
          <Connection from={{x: 80, y: 275}} to={{x:80, y:375}} prequisiteId={missions[2].prequisite_id}  studentToMission={studentToMission}/>

          {/* nach libary */}
          <Connection from={{x: 230, y: 275}} to={{x:230, y:325}} prequisiteId={missions[4].prequisite_id}  studentToMission={studentToMission}/>
          <Connection from={{x: 180, y: 325}} to={{x:280, y:325}} prequisiteId={missions[4].prequisite_id}  studentToMission={studentToMission}/>
          <Connection from={{x: 180, y: 325}} to={{x:180, y:375}} prequisiteId={missions[4].prequisite_id}  studentToMission={studentToMission}/>
          <Connection from={{x: 280, y: 325}} to={{x:280, y:375}} prequisiteId={missions[4].prequisite_id}  studentToMission={studentToMission}/>

          {/* nach serieller monitor */}
          <Connection from={{x: 530, y: 275}} to={{x:530, y:325}} prequisiteId={missions[8].prequisite_id}  studentToMission={studentToMission}/>
          <Connection from={{x: 380, y: 325}} to={{x:680, y:325}} prequisiteId={missions[8].prequisite_id}  studentToMission={studentToMission}/>
          <Connection from={{x: 380, y: 325}} to={{x:380, y:375}} prequisiteId={missions[8].prequisite_id}  studentToMission={studentToMission}/>
          <Connection from={{x: 480, y: 325}} to={{x:480, y:375}} prequisiteId={missions[8].prequisite_id}  studentToMission={studentToMission}/>
          <Connection from={{x: 580, y: 325}} to={{x:580, y:375}} prequisiteId={missions[8].prequisite_id}  studentToMission={studentToMission}/>
          <Connection from={{x: 680, y: 325}} to={{x:680, y:375}} prequisiteId={missions[8].prequisite_id}  studentToMission={studentToMission}/>

          {/* nach drehpotie */}
          <Connection from={{x: 480, y: 375}} to={{x:480, y:425}} prequisiteId={missions[10].prequisite_id}  studentToMission={studentToMission}/>
          <Connection from={{x: 430, y: 425}} to={{x:530, y:425}} prequisiteId={missions[10].prequisite_id}  studentToMission={studentToMission}/>
          <Connection from={{x: 430, y: 425}} to={{x:430, y:450}} prequisiteId={missions[10].prequisite_id} studentToMission={studentToMission}/>
          <Connection from={{x: 530, y: 425}} to={{x:530, y:450}} prequisiteId={missions[10].prequisite_id}  studentToMission={studentToMission}/>
      
          {missions?.map(node => {
            return (
              <Node key={"node_" + node.id} data={node} studentId={studentId} isSelected={selectedNode === node.id} studentToMission={studentToMission} setSelectedNode={setSelectedNode}/>
            )
          })}
        </svg>
      </div>
    </div>
  );
};
}

export default Missions;
